import axios from "axios";
import constants from "../utils/constants.js";
import storage from "../utils/storage.js";

let axiosInstance = axios.create({});

axiosInstance.interceptors.request.use((config) => {
  const token = storage.getToken();
  config.headers={
    Authorization : `Bearer ${token}`,
    "ngrok-skip-browser-warning": "69420",
    
  }
  return config;
});

export const getRequest = (path, success, error, config) => {
  axiosInstance
    .get(constants.API_URL + path, {
      ...config,
    })
    .then(success)
    .catch(error);
};

export const postRequest = (path, data, success, error, config) => {
  axiosInstance
    .post(constants.API_URL + path, data, {
      ...config,
    })
    .then(success)
    .catch(error);
};

export const putRequest = (path, data, success, error, config) => {
  axiosInstance
    .put(constants.API_URL + path, data, {
      ...config,
    })
    .then(success)
    .catch(error);
};

export const deleteRequest = (path, data, success, error, config) => {
  axiosInstance
    .delete(constants.API_URL + path, data, {
      ...config,
    })
    .then(success)
    .catch(error);
};

export default {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
};
